import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import { FETCH_STATIC_PAGE_WIDGET_CONFIGURATION_NAME } from './staticPageWidgetConfigurationBreadcrumb.query';

export const StaticPageWidgetConfigurationBreadcrumb = () => {
  const { id } = useParams();
  const { data } = useQuery(FETCH_STATIC_PAGE_WIDGET_CONFIGURATION_NAME, {
    variables: { staticPageWidgetConfigurationId: id ?? '' },
    skip: !id,
  });

  return (
    data?.fetchStaticPageWidgetConfiguration?.staticPageWidgetConfiguration
      ?.name ?? ''
  );
};
